import { REPORT_GAIN_TYPE_COLUMN_LABEL } from "../../../utils/reports/reportDisplayLabels";

export type FieldColumn = {
  key: string;
  value: string;
  locked?: boolean;
  minWidth?: number;
  align?: "left" | "center" | "right";
};

export const OTHER_ASSET_TABLE_SEGMENT = "Other Asset";

export const OTHER_ASSET_REPORT_TYPE_OPTIONS = [
  { value: "Holding", label: "Unrealized" },
  { value: "Transaction", label: "Transaction" },
] as const;

export const OTHER_ASSET_QUICK_REPORTS = [
  { id: "holding", label: "Unrealized", reportType: "Holding" },
  { id: "transaction", label: "Transaction Report", reportType: "Transaction" },
];

export const INVESTOR_COLUMN: FieldColumn = {
  key: "investorDisplay",
  value: "Investor Name",
  locked: true,
  minWidth: 200,
};

/** aumsampaan Other Asset Holding preset */
export const OTHER_ASSET_HOLDING_COLUMNS: FieldColumn[] = [
  { key: "primaryCategory", value: "Primary Category", locked: true, minWidth: 160 },
  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },
  { key: "secondaryCategory", value: "Sec. Category", minWidth: 140 },
  { key: "schemeName", value: "Name", minWidth: 200 },
  { key: "location", value: "Location", minWidth: 140 },
  { key: "investedAmount", value: "Invested", minWidth: 128 },
  { key: "currentAmount", value: "Current", minWidth: 128 },
  { key: "gainLoss", value: "P&L", minWidth: 132 },
  { key: "gainLossPercentage", value: "P&L %", minWidth: 96 },
];

export const OTHER_ASSET_TRANSACTION_COLUMNS: FieldColumn[] = [
  { key: "txnType", value: "Type", locked: true, minWidth: 120 },
  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },
  { key: "currentDate", value: "Current Date", minWidth: 112 },
  { key: "amount", value: "Amount", minWidth: 128 },
  { key: "currentValue", value: "Cur. Amt.", minWidth: 128 },
  { key: "unrealisedGainLoss", value: "Unrealized P&L", minWidth: 132 },
  { key: "realisedGainLoss", value: "Realized P&L", minWidth: 132 },
];

export const getColumnsForOtherAssetReportType = (reportType: string): FieldColumn[] => {
  switch (reportType) {
    case "Transaction":
      return OTHER_ASSET_TRANSACTION_COLUMNS;
    case "Holding":
    default:
      return OTHER_ASSET_HOLDING_COLUMNS;
  }
};

/** Other Asset reports do not require a user-selected date range in aumsampaan. */
export const reportTypeNeedsDateRange = (_reportType: string): boolean => false;
